import React from "react";

import { Helmet } from "react-helmet";
import { Container } from "react-bootstrap";
import Header from "components/layout/Header";
import { useTranslation } from "react-i18next";
import { blobURL } from "common/StringUtils";

const CoolCompanyVsInvozio = () => {
  const comparison2 = `${blobURL}/comparison-2.jpg`;

  const { t } = useTranslation();

  return (
    <div className="network-page">
      <Helmet>
        <title>{t("Invozio is the clear winner against Cool Company")}</title>
        <meta
          name="description"
          content={t(
            "Invozio: For freelancers, by freelancers. More in your wallet with just a 1.4% fee. Simpler, cheaper compared to Cool Company. Try us now!"
          )}
        />
        <meta name="keywords" content="cool company"></meta>
      </Helmet>

      <Header />

      <div className="p-0 self_new negotiate network-page mb-0 nw_add_scc busniness_new">
        <div className="negotiation_wrap new_desgn_insurance inspiration fakt new_margin_header px-0 p-0">
          <Container className="self_new responsive_self">
            <div className="seo_pages">
              <section className="insurns_wrap self-empoyee">
                <div className="container">
                  <div className="row align-items-center p-2">
                    <div className="col-lg-6">
                      <div className="slf_text">
                        <h1 className="security_about text-uppercase mb-0">
                          Cool Company vs Invozio
                        </h1>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="text-right">
                        <img
                          src={comparison2}
                          alt="cool company"
                          className="img-fluid"
                          style={{
                            borderRadius: "20px",
                            width: "380px",
                            height: "320px",
                            padding: "12px",
                          }}
                          loading="lazy"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </section>
              <section className="newdesign">
                <div className="container p-0">
                  <div className="without_background">
                    <h1 className="heading_edit">Cool Company</h1>
                    <div className="new_text">
                      <p>
                        {" "}
                        {t(
                          "Cool Company, like Invozio, is a company that helps freelancers and consultants to invoice without starting their own company. With Cool Company, individuals can easily invoice for their services and the company takes care of taxes, fees and administration. Freelancers can thus focus on their core business and expertise without having to worry about company administration or legal obligations. Their platform is designed to be simple and intuitive to use, making it easier for freelancers to navigate through the financial aspect of their work which is what Invozio has."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t("Overall comparison Cool Company and Invozio")}
                      </h3>
                      <p>
                        {t(
                          "Invozio is also a platform that allows freelancers, small businesses and consultants to send invoices without starting their own business. Just like Cool Company, they take care of taxes, fees and administration for their customers. Invozio is known for its speed and simplicity when it comes to sending invoices, and they offer a variety of features to make it easier for freelancers and small businesses to manage their invoicing."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">
                        {t("How we make an objective assessment")}
                      </h3>
                      <p>
                        {t(
                          "Both Invozio and Cool Company offer similar services aimed at freelancers and small businesses, taking care of much of the administration and legal aspects of running a business. Their aim is to make life easier for freelancers and small businesses by letting them focus on their work instead of worrying about paperwork and taxes. The differences between the two lie mainly in their specific features, user experience, and pricing. Some may find that a platform is a better fit for them based on their specific needs or preferences. It is always recommended to take a closer look at each platform and compare their services and costs before making a decision."
                        )}
                      </p>
                    </div>
                  </div>
                  <div className="with_background">
                    <div className="new_text">
                      <h2 className="mb-2 accident_ins">
                        {t(
                          "To the big question; which of Cool Company and Invozio do I get paid the most as a freelancer?"
                        )}
                      </h2>
                      <p>
                        {t(
                          "Let's take a look at how much a freelancer would earn when billing 10,000 SEK through each platform, based on the information on their websites."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">Invozio</h3>
                      <p>
                        {t(
                          "With Invozio, the fee is 1.4%. So if you invoice SEK 10,000, the fee would be SEK 140. The freelancer thus receives SEK 9,810."
                        )}
                      </p>
                    </div>
                    <div className="new_text">
                      <h3 className="mb-2 accident_ins">Cool Company</h3>
                      <p>
                        {t(
                          "Cool Company charges a fee of 5.96%. So if you invoice SEK 10,000, the fee would be SEK 596. The freelancer thus receives SEK 9,404. Based on these numbers and without taking into account any additional services or benefits that may be offered by each platform, it would appear that the freelancer is making more money per dollar billed through Invozio compared to Cool Company. So if you want more in your wallet every month, you should turn to Invozio."
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
};

export default CoolCompanyVsInvozio;
